/* import __COLOCATED_TEMPLATE__ from './ios.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();